"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../../baseSchema");
const baseClickSchema_1 = require("../../baseSchema/baseClickSchema");
class ClickAccessHotmartClub extends baseClickSchema_1.BaseClickSchema {
    constructor() {
        super({ componentName: baseSchema_1.ComponentNames.BUTTON_ACCESS_HOTMART_CLUB });
        this.entity = baseSchema_1.DataHubEntities.ADMIN;
        this.action = baseSchema_1.ActionsName.CLICK_ACCESS_HOTMART_CLUB;
        this.screenName = baseSchema_1.ScreenNames.CONFIG_MANAGER;
        this.url = location.href;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            entity: this.entity,
            action: this.action,
            screenName: this.screenName,
            url: this.url
        };
    }
}
exports.default = ClickAccessHotmartClub;
